import { cn } from "@/lib/utils";

interface OnboardingStepperProps {
  steps: string[];
  currentStep: number;
}

export function OnboardingStepper({
  steps,
  currentStep,
}: OnboardingStepperProps) {
  return (
    <div className="w-full mb-2">
      <div className="flex items-center">
        {steps.map((_, index) => (
          <div key={index} className="flex items-center flex-1">
            <div className="flex justify-center w-full">
              <div
                className={cn(
                  "flex items-center justify-center w-10 h-10 rounded-full text-sm font-medium border-2",
                  index < currentStep
                    ? "bg-green-600 text-white border-gray-300"
                    : index === currentStep
                      ? "border-primary text-primary bg-background"
                      : "border-muted-foreground/30 text-muted-foreground bg-background",
                )}
              >
                {index < currentStep ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-5 w-5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                ) : (
                  index + 1
                )}
              </div>
            </div>
            {index < steps.length - 1 && (
              <div
                className={cn(
                  "h-1 flex-1 mx-4",
                  index < currentStep ? "bg-primary" : "bg-muted-foreground/30",
                )}
              />
            )}
          </div>
        ))}
      </div>
      <div className="flex justify-between mt-2 px-1 text-xs text-muted-foreground">
        {steps.map((step, index) => (
          <div
            key={index}
            className={cn(
              "font-medium text-center flex-1",
              index <= currentStep ? "text-primary" : "",
              index === 0 ? "-ml-5" : "",
              index === 2 ? "-ml-2" : "",
            )}
          >
            {step}
          </div>
        ))}
      </div>
    </div>
  );
}
